import React from 'react'

const WebsiteMaintaince = () => {
  return (
    <div>WebsiteMaintaince</div>
  )
}

export default WebsiteMaintaince